import React from 'react'
import { MenuItem } from '@material-ui/core'
import { timeDifference } from '../utils/DateTimeFormat'

//Huy: geo distance is not correct so we use google service for this
const getDistanceMatrix = (service, data) =>
  new Promise((resolve, reject) => {
    service.getDistanceMatrix(data, (response, status) => {
      if (status === 'OK') {
        resolve(response)
      } else {
        reject(response)
      }
    })
  })

export const calculateDistance = async (startPlace, endPlace) => {
  const service = new google.maps.DistanceMatrixService()
  const result = await getDistanceMatrix(service, {
    origins: [startPlace],
    destinations: [endPlace],
    travelMode: google.maps.TravelMode.DRIVING
  })

  return result.rows[0].elements[0].distance.value / 1000
}

export const dynamicSort = (property) => {
  var sortOrder = 1
  if (property[0] === '-') {
    sortOrder = -1
    property = property.substr(1)
  }
  return function (a, b) {
    /* next line works with strings and numbers,
     * and you may want to customize it to your needs
     */
    var result =
      a[property] > b[property] ? -1 : a[property] < b[property] ? 1 : 0
    return result * sortOrder
  }
}

export const getFullDayAllowanceValues = (days, hours, allowances) => {
  if (days > 0 && hours > 6)
    return Math.max(
      days +
        (allowances.meal_allowance > 0 ? 0 : 1) -
        allowances.part_time_allowance -
        Math.floor(allowances.meal_allowance / 2),
      0
    )
  if (days > 0 && hours >= 2 && hours <= 6)
    return Math.max(
      Math.floor(
        days -
          (allowances.part_time_allowance > 0
            ? allowances.part_time_allowance - 1
            : 0) -
          allowances.meal_allowance / 2
      ),
      0
    )
  else if (days > 0)
    return Math.max(
      Math.floor(
        days - allowances.part_time_allowance - allowances.meal_allowance / 2
      ),
      0
    )
  else return 0
}

export const getPartDayAllowanceValues = (days, hours, allowances) => {
  if (days > 0 && hours < 2) {
    return Math.max(
      Math.floor(
        days - allowances.full_time_allowance - allowances.meal_allowance / 2
      ),
      0
    )
  } else if (days > 0 && hours > 6)
    return Math.max(
      days +
        (allowances.meal_allowance > 0 ? 0 : 1) -
        (allowances.full_time_allowance || 0) -
        Math.floor(allowances.meal_allowance / 2),
      0
    )
  else if (days > 0)
    return Math.max(
      Math.floor(
        days +
          (allowances.meal_allowance > 0 ? 0 : 1) -
          (allowances.full_time_allowance || 0) -
          allowances.meal_allowance / 2
      ),
      0
    )
  else if (days === 0 && hours > 6)
    return Math.max(
      Math.floor(
        1 - allowances.full_time_allowance - allowances.meal_allowance / 2
      ),
      0
    )
  else return 0
}

export const getMealAllowanceValues = (days, hours, formValues) => {
  if (days > 0 && hours > 10)
    return Math.max(
      2 *
        (days +
          1 -
          formValues.part_time_allowance -
          formValues.full_time_allowance),
      0
    )
  else if (days > 0 && hours > 6)
    return Math.max(
      2 *
        (days +
          1 / 2 -
          formValues.part_time_allowance -
          formValues.full_time_allowance),
      0
    )
  else if (days > 0)
    return Math.max(
      2 *
        (days -
          formValues.part_time_allowance -
          formValues.full_time_allowance),
      0
    )
  else if (days === 0 && hours > 6 && hours <= 10)
    return Math.max(
      1 - formValues.part_time_allowance - formValues.full_time_allowance,
      0
    )
  else return 0
}

export const getDaysAndHours = (
  _start_date,
  _end_date,
  _start_time,
  _end_time
) => {
  const start_date = new Date(_start_date)
  const end_date = new Date(_end_date)
  const start_time = new Date(_start_time)
  const end_time = new Date(_end_time)

  start_date.setHours(start_time.getHours())
  start_date.setMinutes(start_time.getMinutes())
  start_date.setSeconds(0)
  start_date.setMilliseconds(0)
  end_date.setHours(end_time.getHours())
  end_date.setMinutes(end_time.getMinutes())
  end_date.setSeconds(0)
  end_date.setMilliseconds(0)

  let dayDifferenceFloat =
    (end_date.getTime() - start_date.getTime()) / (1000 * 60 * 60 * 24)
  let leftOver = Math.round(
    (dayDifferenceFloat - Math.floor(dayDifferenceFloat)) * 1e8
  )
  let dayLimit = Math.round((10 / 24) * 1e8)
  const dayDifference =
    leftOver > dayLimit
      ? Math.ceil(dayDifferenceFloat)
      : Math.floor(dayDifferenceFloat)
  const timeDiff =
    leftOver > dayLimit ? 0 : timeDifference(start_date, end_date)
  return {
    days: dayDifference,
    hours: timeDiff
  }
}

export const createMenuItems = (rows) =>
  Array(!!rows ? rows + 1 : 1)
    .fill()
    .map((_, index) => (
      <MenuItem key={index} value={index}>
        {JSON.stringify(index)}
      </MenuItem>
    ))
